module.exports = __webpack_public_path__ + "static/media/fun-shapes.9f53dd45.png";